<template>
  <div>
    <!-- <div id="app" @dragstart="handleDragStart" @touchstart="handleTouchStart"> -->
    <div id="app">
      <div id="preload_area" v-if="getAppLevelSetting('maskCssTransition')===true">
        <div id="mask-nature1"></div>
        <div id="mask-nature2"></div>
        <div id="mask-urban1"></div>
        <div id="mask-urban2"></div>
        <div id="mask-building1"></div>
        <div id="mask-building2"></div>
      </div>
      <main-container id="appMainContainer" :back-link="backLink" :showTopNav="showTopNav">
        <app-page-loading-icon></app-page-loading-icon>
        <!-- in-out is needed to bring in the next page before the current page exists -->
        <transition
          appear
          :name="transitionName"
          mode="in-out"
          v-on:before-enter="beforeEnter"
          v-on:after-leave="afterLeave"
        >
          <!-- Need to keep alive all pages uses background video players -->
          <keep-alive>
            <router-view
              :key="$route.fullPath"
              class="view child-view"
              @require-back-link="handleisBackLinkNeeded"
              @show-top-nav="handleShowTopNav"
            />
          </keep-alive>
        </transition>
      </main-container>
      <!-- Design overlay -->
      <design-dev-tools v-if="getAppLevelSetting('designDevTools')===true"/>
    </div>
    <!-- Utility for 3D modeling -->
    <!--<babylon-dev-tools v-if="getAppLevelSetting('babylonDevTools')===true"/>-->
    <!-- Utility for animations-->
    <gs-dev-tools v-if="getAppLevelSetting('gsDevTools')===true"/>
  </div>
</template>


<script>
import { EventBus } from "./assets/js/event-bus";

import MainContainer from "./components/TheMainContainer";
// import BabylonDevTools from './components/dev-tools/Babylon-DevTools';
// import GsDevTools from './components/dev-tools/green-sock/GS-DevTools';
import DesignDevTools from "./components/dev-tools/Design-DevTools";
import AppPageLoadingIcon from "./components/ThePageLoadingIcon";
import { setTimeout } from 'timers';

export default {
  name: "app",
  components: {
    AppPageLoadingIcon,
    DesignDevTools,
    // GsDevTools,
    // BabylonDevTools,
    MainContainer
  },
  created() {
    EventBus.$on("router-view-loaded", this.handleRouterViewLoaded);
  },
  mounted() {
    this.transitions = this.getAppLevelSetting("transitions");

    // dynamically load deploy target css file
    // depends on the deploy setting, it loads the defined bin-<deploy>.css dynamically
    const deployTarget = this.getAppLevelSetting("deploy");
    if (deployTarget) {
      const head = document.getElementsByTagName("body")[0];
      const link = document.createElement("link");
      link.id = deployTarget;
      link.rel = "stylesheet";
      link.type = "text/css";
      link.href = `./static/assets/css/bin-${deployTarget}.css`;
      link.media = "all";
      head.appendChild(link);
    }
    // console.log(this.$router);
  },
  methods: {
    beforeEnter(el) {
      // console.log(`App.vue - before Enter transition  ${this.toRoute}`);
      // EventBus.$emit('transition-before-enter', this.toRoute);
      if (this.$el && this.$el.querySelector(".hoverable-svg")) {
        this.$el.querySelector(".hoverable-svg").style.display = "none";
      }
    },
    afterLeave(el) {
      // console.log(`App.vue - after Leave ${this.fromRoute}`);
      EventBus.$emit("transition-afterLeave-route", this.fromRoute);
    },
    handleRouterViewLoaded() {
      window.loadSpinner = false;
      if (this.$el && this.$el.querySelector("#loadingScreen")) {
        this.$el.querySelector("#loadingScreen").style.visibility = "hidden";
      }
    },

    handleHoverableClick(hoverable) {     
      // console.log('handle hoverable click')
      this.$refs["appMainContainer"].handleClick(hoverable);
    },
    handleisBackLinkNeeded(value) {
      this.backLink = value;
    },
    /**
     * To show or hide top nav bar (back button, hamburger and GE logo)
     *  this.$emit('show-top-nav', 'none');  // hide
     *  this.$emit('show-top-nav', 'block'); // show
     * @param show
     */
    handleShowTopNav(show) {
      this.showTopNav = show;
    },
    /**
     * To prevent pinch zoom
     * @param evt
     * @returns {boolean}
     */
    handleTouchStart(event) {
      // console.log('touch event: '+ event.touches.length);
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    },
    /**
     * To prevent draging of the following tag
     * @param evt
     * @returns {boolean}
     */
    handleDragStart(evt) {
      if (evt.target.nodeName.match(/^(IMG|DIV|SPAN|A)$/i)) {
        console.log("drag start");
        evt.preventDefault();
        return false;
      }
      return true;
    },
    getTransitionFromConfig(to, from) {
      if (this.transitions) {
        for (
          let currTransition = 0;
          currTransition < this.transitions.map.length;
          currTransition++
        ) {
          for (
            let fromTo = 0;
            fromTo < this.transitions.map[currTransition].fromTos.length;
            fromTo++
          ) {
            const fromView = this.transitions.map[currTransition].fromTos[
              fromTo
            ].from;
            const toView = this.transitions.map[currTransition].fromTos[fromTo]
              .to;
            if (from.name === fromView && to.name === toView) {
              return this.transitions.map[currTransition].transition;
            }
          }
        }
      }
    },
    updateTransitionName(to, from){
      /**
       * Default transition can be defined in config.json
       */
      const defaultTransitionName = this.transitions.default || "slide-left";

      this.fromRoute = from.name;
      this.toRoute = to.name;

      // mask-nature mask-urban mask-building  (1/2)
      // const trans = ['', 'fade', 'slide-right',
      //   'slide-left', 'slide-up', 'slide-down',
      //   'mask-nature1', 'mask-building1', 'mask-urban1',
      //   'mask-nature2', 'mask-building2', 'mask-urban2'];
      // // debugger;
      // this.transitionName = trans[Math.floor(Math.random() * (trans.length))];
      // this.transitionIndex = this.transitionIndex + 1 >= trans.length ? 0 : this.transitionIndex + 1;
      // this.transitionName = trans[this.transitionIndex];
      // this.transitionName = 'mask-nature1';
      this.transitionName = defaultTransitionName; // default transition.

      // debugger;
      const toDepth = to.path.split("/").length;
      const fromDepth = from.path.split("/").length;
      // // console.log(' from '); console.log(from);
      // // console.log(' to '); console.log(to);
      // // console.log('route changes from ' + fromDepth + ' to ' + toDepth);
      this.transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
      // this.transitionName = toDepth < fromDepth ? 'slide-right' : defaultTransitionName;
      // /* Customization */
      // this.transitionName = to.name === 'Home' ? 'slide-right' : this.transitionName;

      if (to.name === "Home" && from.name === null) {
        // initial load
        this.transitionName = "";
      }
      // Override transition definition from config.json only if it found exact match
      this.transitionName = this.getTransitionFromConfig(to, from) || this.transitionName;
      console.log(`App.vue watch route change ${from.name} to ${to.name} and transition is ${this.transitionName}`);
    },
    callAdobePageDataAnalytics(to){
      if (window._satellite && to) {
        window.GEAnalytics = window.GEAnalytics || {};
        window.GEAnalytics.pageData = window.GEAnalytics.pageData || {};
        window.GEAnalytics.pageData.pageName = to.meta.adobe.page;
        window.GEAnalytics.pageData.channel = 'productexplorers';
        window.GEAnalytics.pageData.pageURL = to.fullPath;
        window.GEAnalytics.pageData.business = 'grid';
        window.GEAnalytics.pageData.subBusiness = '';
        window.GEAnalytics.pageData.country = 'us';
        window.GEAnalytics.pageData.language = 'english';
        window.GEAnalytics.pageData.category = '';
        console.log(`${window.GEAnalytics.pageData.pageName} visited`);
        console.log(`GEAnalytics - ${JSON.stringify(window.GEAnalytics.pageData)}`)
        // console.log(`Call pageBottom`)
        _satellite.pageBottom();
        // debugger
        // console.log(`finish pageBottom`)
      }
    },

    /**
     * Attempt to use javascrpt to preload mask-css sprite but
     * the url of the mask: url doesn't match the path, thus
     * the preloaded sprites are not used.
     * Tried webpack (url: false) in url-loader
     */
    //   preloadCssMask() {
    //     const images = [];
    //     debugger;
    //     const preloadArea = document.querySelector('#preload_area');
    //
    //     function preload(cssMask) {
    //       for (var i = 0; i < cssMask.length; i++) {
    //         images[i] = new Image();
    //         images[i].src = cssMask[i];
    //         preloadArea.appendChild(images[i]);
    //       }
    //     }
    //     preload([
    //       './static/assets/css/mask/urban-sprite.png',
    //       './static/assets/css/mask/urban-sprite-2.png',
    //       './static/assets/css/mask/building-sprite.png',
    //       './static/assets/css/mask/building-sprite-2.png',
    //       './static/assets/css/mask/nature-sprite-2.png',
    //       './static/assets/css/mask/nature-sprite.png',
    //     ]);
    //   },
  },

  watch: {
    // call again the method if the route changes
    $route(to, from) {
      this.updateTransitionName(to, from)
      // setTimeout(()=>{this.callAdobePageDataAnalytics(to)},2000)
      // this.callAdobePageDataAnalytics(to)
    }
  },
  data() {
    return {
      fromRoute: "",
      toRoute: "",
      backLink: "Home",
      transitionName: "fade",
      showTopNav: "block",
      transitionIndex: 0,
      transitions: {}
    };
  }
};
</script>

<style>
@import "assets/css/transition.css";
@import "assets/css/mask/mask-transition.css";

#preload_area {
  width: 0;
  height: 0;
}

#app {
  font-family: "GEInspiraSansRegular", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: black;
}

/* ensure font are white by default */
#app p {
  color: white;
}

/* remove clear input button */
#app input::-ms-clear {
  display: none;
}

.child-view {
  position: absolute;
}
#loadingScreen {
  width: 100%;
  height: 100%;
  background-color: #000000;
  background-color: rgba(0, 0, 0, 0.75);
  background-color: transparent \9;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#BF000000, endColorstr=#BF000000);
  zoom: 1;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1000;
  text-align: center;
  opacity: 1;
  filter: alpha(opacity=100);
  zoom: 1;
}

#loadingScreen img {
  width: 50px;
  position: relative;
  top: 45%;
}

.msg-overlay { 
  height: 100%;
  width: 800px;
  position: absolute;
  top: 0px;
  left: 0px;
  /* background: rgb(0, 0, 0); */
  background: black;
  opacity: 0.75;
  overflow: hidden;
  border-radius: 2px;
}

.msg-overlay::after {
  /* Add the blur effect */
  -webkit-filter: blur(10px);
  -moz-filter: blur(10px);
  -o-filter: blur(10px);
  -ms-filter: blur(10px);
  filter: blur(10px);

  box-shadow: inset 0 0 0 200px rgba(255, 255, 255, 0.05);
}

hr {
  display: block;
  position: absolute;
  height: 1px;
  border: 0;
  top: 410px;
  left: 65px;
  width: 237px;
  border-top: 1px solid #668d97;
  margin: 1em 0;
  padding: 0;
}

.msg {
  padding: 0 65px;
  position: absolute;
  width: 800px;
  font-size: 30px;
  color: white;
  top: 550px;
  line-height: 48px;
}

.msgFont-Red {
  font-weight: bold;
  font-size: 40px;
  color: red;
}

.nav-btn {
  position: absolute;
  top: 910px;
}


  
a {
  color: white !important;
}

/* unvisited link */
a:link {
  color: white!important;
}

/* visited link */
a:visited {
  color: white!important;
}

/* mouse over link */
a:hover {
  color: white!important;
}

/* selected link */
a:active {
  color: white!important;
}

.loadingTitle {
  position: absolute;
  top: 200px;
  left: 63px;
  height: 180px;
  width: 700px;
  background: url("../static/images/title.png");
  -webkit-animation: playTitle .8s steps(23) forwards;
  -moz-animation: playTitle .8s steps(23) forwards;
  -ms-animation: playTitle .8s steps(23) forwards;
  -o-animation: playTitle .8s steps(23) forwards;
  animation: playTitle .8s steps(23) forwards;
}

@-webkit-keyframes playTitle {
  from {
    background-position: 0px;
  }
  to {
    background-position: -16100px;
  }
}

@-moz-keyframes playTitle {
  from {
    background-position: 0px;
  }
  to {
    background-position: -16100px;
  }
}

@-ms-keyframes playTitle {
  from {
    background-position: 0px;
  }
  to {
    background-position: -16100px;
  }
}

@-o-keyframes playTitle {
  from {
    background-position: 0px;
  }
  to {
    background-position: -16100px;
  }
}

@keyframes playTitle {
  from {
    background-position: 0px;
  }
  to {
    background-position: -16100px;
  }
}

</style>



// WEBPACK FOOTER //
// App.vue?4fdbc778